import { css } from "@emotion/react"

export const fullPageLoadingWrapperStyle = css`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`
